/* tslint:disable */
export {};

declare global {
  interface Number {
    /**
     * Pads a number with leading zeros
     * @returns {string}
     */
    pad(size?);
  }
}

/**
 * Taken from https://stackoverflow.com/a/11187738
 * @description
 * ```
 * Usage:
 * 1.pad() // 01
 * 1.pad(3) // 001
 * 10,pad // 10
 * ```
 * @param {size} size the size the string should be. E.g 2 will return a 2 character string
 * @returns {string}
 */
Number.prototype.pad = function (size): string {
  let s = String(this);
  while (s.length < (size || 2)) {
    s = "0" + s;
  }
  return s;
};



// WEBPACK FOOTER //
// ./src/utils/number/number-prototype.utils.ts